import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import WhatsAppWrapper from "./components/Whatsapp/WhatsAppWrapper";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
    <WhatsAppWrapper />
  </BrowserRouter>
);
